import { render, staticRenderFns } from "./FinishedGoodsOutboundDetail.vue?vue&type=template&id=37bc6574&scoped=true"
import script from "./FinishedGoodsOutboundDetail.vue?vue&type=script&lang=js"
export * from "./FinishedGoodsOutboundDetail.vue?vue&type=script&lang=js"
import style0 from "./FinishedGoodsOutboundDetail.vue?vue&type=style&index=0&id=37bc6574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc6574",
  null
  
)

export default component.exports